import { Checkbox, FormControlLabel } from "@mui/material";
import { type FC, useEffect, useState } from "react";
import { IPopupTranslations } from "./FilterItem";
import { IFilterListItem } from "./FilterPopupList";
import GooglePlacesAutocomplete from "src/components/CommonComponents/GooglePlacesAutoComplete";
import { googleMapsInput } from "src/styles/globalStyles";

interface FilterPopupLocationProps {
  itemList: IFilterListItem[];
  setItemList: (a: IFilterListItem[]) => void;
  popupTranslation: IPopupTranslations;
}

const FilterPopupLocation: FC<FilterPopupLocationProps> = ({
  popupTranslation,
  itemList,
  setItemList,
}) => {
  const [value, setValue] = useState<any>();

  const updateList = (item: IFilterListItem, setActive: boolean) => {
    if (setActive) {
      if (value)
        setItemList([
          ...itemList,
          { translation: value.label, value: value.label, isActive: true },
        ]);
    } else {
      const newList = [...itemList].filter((i) => i.value != item.value);
      setItemList(newList);
    }
  };

  useEffect(() => {
    if (value)
      updateList(
        { value: value.label, translation: value.label, isActive: true },
        true
      );
    // TODO: exhaustive deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="filter_popup filter_popup_location">
      {/* <div className="filter_popup_subtitle">{popupTranslation.title}</div> */}
      <div className="filter_popup_search">
        <GooglePlacesAutocomplete
          selectProps={{
            placeholder: popupTranslation.placeholder,
            onChange: setValue,
            value,
            theme: googleMapsInput.theme,
            styles: googleMapsInput.styles,
          }}
          types={["locality", "country"]}
        />
      </div>
      {itemList.filter((i) => i.isActive).length > 0 && (
        <div className="filter_popup_list_wrap">
          <div className="filter_popup_list ">
            {itemList
              .filter((i) => i.isActive)
              .map((item, i) => (
                <FormControlLabel
                  className="filter_popup_list_item"
                  key={item.value + i}
                  control={
                    <Checkbox
                      size="small"
                      color="default"
                      checked={true}
                      onClick={() => updateList(item, false)}
                    />
                  }
                  label={item.translation}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};
export default FilterPopupLocation;
